export default "__VITE_ASSET__DFB8Y5Ic__"